<template>
  <div class="hello">

    <div v-if="!isOnline" class="offline-alert">
      🔌 ارتباط با اینترنت قطع شده!
    </div>
    <div class="row my-4">
<!--      <paginate
          :page-count="50"
          :page-range="3"
          :margin-pages="2"
          :click-handler="clickCallback"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :container-class="'pagination'"
          :page-class="'page-item'"
      >
      </paginate>-->
      <paginate
          v-model="page"
          :page-count="pagecount"
          :page-range="3"
          :margin-pages="2"
          :click-handler="clickCallback"
          :prev-text="'قبلی'"
          :next-text="'بعدی'"
          :container-class="'pagination'"
          :page-class="'page-item'"
      >
      </paginate>
    </div>


    <p v-if="error">{{ error }}</p>
    <p v-if="loading">در حال بارگذاری...</p>

    <div v-if="!loading && !error"   class="row row-cols-1 row-cols-sm-2  row-cols-md-3 row-cols-lg-4 row-cols-xl-4 g-4">

      <div class="col" v-for="user in users" :key="user.id">
        <div class="card h-100">

          <div v-if="!loaded" class="image-loader-placeholder text-center my-3">
            <span class="spinner-border spinner-border-sm"></span>بارگذاری تصویر...
          </div>


          <img  v-show="loaded"  @load="onLoad" @error="onError" :src="user.download_url" :alt="user.id" class="card-img-top"  >
          <div class="card-body">
            <h5 class="card-title">
              <RouterLink class=" " :to="'/product/'+user.id" > {{ user.author }} ({{ user.id }})</RouterLink>

            </h5>
            <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
          </div>
        </div>
      </div>


    </div>


<!--    <div class="row">
      <button
          v-for="page in 50"
          :key="page"
          :class="{ active: page === currentPage }"
          @click="$emit('update:currentPage', page)"
      >
        {{ page }}
      </button>
    </div>-->

<!--    <div class="row my-3">
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item"><a class="page-link" href="#">Previous</a></li>
          <li class="page-item" v-for="item in 50" :key="item"><a class="page-link" :href="`/products?page=${item}`">{{ item }}</a></li>
&lt;!&ndash;          <li class="page-item"><a class="page-link" href="/products?page=2">2</a></li>
          <li class="page-item"><a class="page-link" href="/products?page=3">3</a></li>
          <li class="page-item"><a class="page-link" href="/products?page=4">Next</a></li>&ndash;&gt;
        </ul>
      </nav>
    </div>-->


<!--
<div class="row">
  <nav>
    <ul class="pagination justify-content-center">
      <li class="page-item" :class="{ disabled: currentPage === 1 }">
        <button class="page-link" @click="changePage(currentPage - 1)">قبلی</button>
      </li>

      <li
          v-for="page in visiblePages"
          :key="page"
          class="page-item"
          :class="{ active: currentPage === page }"
      >
        <button class="page-link" @click="changePage(page)">

          {{ page }}
&lt;!&ndash;          <a class="" :href="`/products?page=${page}`">{{ page }}</a>&ndash;&gt;
        </button>
      </li>

      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
        <button class="page-link" @click="changePage(currentPage + 1)">بعدی</button>
      </li>
    </ul>
  </nav>
</div>
-->






<!--    <div>
      <h2>لیست کاربران</h2>
      <ul>
        <li v-for="user in users" :key="user.id">
          <img :src="user.download_url" :alt="user.id" width="200" height="200">
          {{ user.author }}
        </li>
      </ul>
      <p v-if="loading">در حال بارگذاری...</p>
      <p v-if="error">{{ error }}</p>
    </div>-->

    <!--    <div class="container">
          <div class="row">
            <div class="col-6 border border-danger">
              <img :src="require('@/assets/img/logo.png')" class="img-thumbnail bg-transparent border-0 mt-3" alt="ss"
                   width="250" height="60">

            </div>
            <div class="col-6 border border-success">
              <img src="../../public/img/logo.gif" class="img-thumbnail bg-transparent border-0 mt-3" alt="ss" width="250"
                   height="60">
            </div>
          </div>
        </div>-->
  </div>
</template>

<script setup>
import { ref, onMounted ,computed ,onUnmounted  } from 'vue'
import axios from 'axios'
import { useRoute,useRouter  } from 'vue-router'
import Paginate from 'vuejs-paginate-next';

// import { useStore } from 'vuex'

// const store = useStore()
const route = useRoute()
const router = useRouter()

const users = ref([])
// const items = ref([...1085])
const loading = ref(false)
const error = ref('')
const items = ref(1000)
const pagecount = ref('')
// const page = route.query.page ?? 1
const page = (route.query.page) || 1


/*const perPage = ref(3)
const currentPage = ref(1)
const rows = ref(1085)*/

// paginate: Paginate,

const paginate = computed(() => Paginate)

async function clickCallback (pageNum)  {
  console.log(pageNum)
  // router.push({ query: {  page: pageNum } })
  router.push({ path: '/products', query: { page: pageNum } })
  loading.value = true
  try {
    // const response = await axios.get('https://picsum.photos/v2/list')
    const response = await axios.get('https://picsum.photos/v2/list?page='+pageNum+'&limit=20')
    users.value = response.data
  } catch (err) {
    error.value = 'خطا در دریافت اطلاعات'
    console.error(err)
  } finally {
    loading.value = false
  }



}


onMounted(async () => {

  console.log(page)


  pagecount.value=Math.floor(items.value / 20)

  loading.value = true
  try {

    const response = await axios.get('https://picsum.photos/v2/list?page='+page+'&limit=20')
    // const response = await axios.get('https://picsum.photos/v2/list')
    /*const response = await axios.get('https://fixstyle.ir/api/user',{
      headers: {
        Authorization: `Bearer ${store.getters.getToken}`
      }
    })*/
    users.value = response.data
    console.log(response.data)
  } catch (err) {
    error.value = 'خطا در دریافت اطلاعات'
    console.error(err)
  } finally {
    loading.value = false
  }
})


const isOnline = ref(navigator.onLine)
function updateOnlineStatus() {
  isOnline.value = navigator.onLine
  if (isOnline.value){
    clickCallback(route.query.page)
  }
}

onMounted(() => {
  window.addEventListener('online', updateOnlineStatus)
  window.addEventListener('offline', updateOnlineStatus)
})

onUnmounted(() => {
  window.removeEventListener('online', updateOnlineStatus)
  window.removeEventListener('offline', updateOnlineStatus)
})

const loaded = ref(false)

function onLoad() {
  loaded.value = true
}
const onError = () => {
  loaded.value = false
}

// const perPage = 20
// const currentPage = ref(1)

// const totalPages = computed(() => Math.ceil(1085 / perPage))

/*const paginatedProducts = computed(() => {
  const start = (currentPage.value - 1) * perPage
  return products.value.slice(start, start + perPage)
})*/

// تعداد صفحات نمایشی در pagination
// const maxVisible = 5

/*const visiblePages = computed(() => {
  const pages = []
  let start = Math.max(currentPage.value - Math.floor(maxVisible / 2), 1)
  let end = start + maxVisible - 1

  if (end > totalPages.value) {
    end = totalPages.value
    start = Math.max(end - maxVisible + 1, 1)
  }

  for (let i = start; i <= end; i++) {
    pages.push(i)
  }

  return pages
})

async function changePage(page) {

  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page

    try {
      // const response = await axios.get('https://picsum.photos/v2/list')
      const response = await axios.get('https://picsum.photos/v2/list?page='+page+'&limit=20')
      users.value = response.data
    } catch (err) {
      error.value = 'خطا در دریافت اطلاعات'
      console.error(err)
    } finally {
      loading.value = false
    }



  }
}*/








</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

.pagination .page-item .page-link{
  cursor: pointer;

}
.page-item {
  cursor: pointer;

}
.page-link{
  cursor: pointer;

}


.offline-alert {
  background: #ffc107;
  padding: 10px;
  text-align: center;
  color: #000;
  font-weight: bold;
}
</style>
